<!-- TnC Model -->
<button type="button" class="btn btn-primary" id="openUserTnc" [hidden]="true" data-toggle="modal" data-target="#userTncModal"
  data-backdrop="static" data-keyboard="false">Hidden Btn</button>

<div class="modal fade" id="userTncModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="apiAccessTitle">User Terms and Conditions Acceptance</h5>
        <!-- <h5 class="modal-title" id="apiAccessTitle">{{tnc.name}}</h5> -->
        <button id="closeUserTnc" type="button" class="close" [hidden]="true" data-dismiss="modal">CANCEL</button>
      </div>
      <div class="modal-body">
        <div class="row p-3">
          <div class="col-12 mt-4">
            <div *ngIf="tnc.url" class="custom-control custom-checkbox float-left">
              <input type="checkbox" class="custom-control-input font13-400" id="cbAcceptUserTnC"
                [(ngModel)]="isUserTnCAccepted">
              <label class="custom-control-label lh-23" for="cbAcceptUserTnC">Check here to indicate that you have read and
                agree to the&nbsp;
                <a class="font14-600-link" (click)="getTncData()" href="javascript:void(0)">NCC User Terms and Conditions.</a>
              </label>
            </div>
          </div>
          <div *ngIf="tnc.effectiveDate" class="col-12 mt-3 font14-400"><span class="text-muted">Effective
              From:&nbsp;</span><span>{{tnc.effectiveDate | date:'MMM d, y'}}</span></div>

          <div class="col-12 mt-5 text-center">
            <button type="button" [disabled]="!isUserTnCAccepted" class="btn btn-primary btn-block"
              (click)="acceptTnc()">Accept and Continue</button>
          </div>
        </div>
      </div>
      <!-- <div class="modal-footer">
        <div class="row width-100">
          <div class="col-12">
            <button type="button" [hidden]="true" [disabled]="!isUserTnCAccepted" class="btn btn-primary float-right"
              (click)="acceptTnc()">Accept</button>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>